import axios from '../../axios';
import * as TYPES from '../types';

const state = {
  companyInfo: null,
};
const getters = {
  companyInfo: state => state.companyInfo,
};
const mutations = {
  [TYPES.SET_COMPANY_INFO](state, payload) {
    state.companyInfo = payload;
  },
};
const actions = {
  /**
   * 获取企业信息
   * @param commit
   */
  getCompanyInfo: ({commit}, cb) => {
    commit(TYPES.SET_LOADING, true);
    axios.get("/company-reviews/me").then(response => {
      commit(TYPES.SET_COMPANY_INFO, response.data);
      commit(TYPES.SET_LOADING, false);
      if (cb) {
        cb();
      }
    }).catch(reason => {
      if (reason.response.data.message === '找不到') {
        axios.get("/companies/me").then(res => {
          commit(TYPES.SET_COMPANY_INFO, res.data);
          commit(TYPES.SET_LOADING, false);
          if (cb) {
            cb();
          }
        })
      } else {
        commit(TYPES.SET_ERROR, reason.response.data.message);
        commit(TYPES.SET_LOADING, false);
      }
    })
  },

  submitCompanyInfo: ({commit}, {companyId, item}) => {
    //验证
    if (!item.contactName) {
      commit(TYPES.SET_ERROR, '请输入联系人姓名');
      return;
    }
    if (/^1\d{10}$/.test(item.phoneNumber)===false) {
      commit(TYPES.SET_ERROR, '请输入正确的手机号');
      return;
    }
    if (!item.legalRepresentative) {
      commit(TYPES.SET_ERROR, '请输入法人');
      return;
    }
    if (/^\d+(-\d+)*$/.test(item.phoneNumber)===false) {
      commit(TYPES.SET_ERROR, '请输入正确的电话');
      return;
    }
    if (!item.registeredAddress) {
      commit(TYPES.SET_ERROR, '请输入详细注册地址');
      return;
    }
    if (!item.taxType) {
      commit(TYPES.SET_ERROR, '请选择税务性质');
      return;
    }
    if (!item.taxId) {
      commit(TYPES.SET_ERROR, '请输入税号');
      return;
    }
    if (!item.receiptTitle) {
      commit(TYPES.SET_ERROR, '请输入发票抬头');
      return;
    }
    if(item.contactEmail){
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(!pattern.test(item.contactEmail)){
        commit(TYPES.SET_ERROR, '请输入正确的邮箱');
        return;
      }
    }
    if(item.website){
      const pattern = /^(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
      if(!pattern.test(item.website)){
        commit(TYPES.SET_ERROR, '请输入正确的网址');
        return;
      }
    }
    if(item.postalCode){
      const pattern = /^\d{6}$/;
      if(!pattern.test(item.postalCode)){
        commit(TYPES.SET_ERROR, '请输入正确的邮编');
        return;
      }
    }
    if(item.registeredCapitalTenK){
      const pattern = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;  ///^\d+$/
      if(!pattern.test(item.registeredCapitalTenK)){
        commit(TYPES.SET_ERROR, '请输入正确的金额');
        return;
      }
    }
//去掉录入后，又不想录入 输入的空项
    for (let i in item) {
      if (item[i] === "") {
        delete item[i];
      }
    }

    commit(TYPES.SET_LOADING, true);
    axios
      .put("/company-reviews/" + companyId, item)
      .then((res) => {
        //this.$store.dispatch("fetchMiniCompanies", {role: this.currentUser.role});
        commit(TYPES.SET_LOADING, false);
        commit(TYPES.SET_ERROR, '修改成功');
      })
      .catch(reason => {
        if (reason.response.data.message === '找不到') {

          axios
            .post("/company-reviews",item)
            .then((res) => {
              //this.$store.dispatch("fetchMiniCompanies", {role: this.currentUser.role});
              // this.$confirm("提交成功", {buttonFalseText: null}).then(() => {
              //   this.cancel();
              // });
              commit(TYPES.SET_ERROR, '提交成功');
              commit(TYPES.SET_LOADING, false);
            })
            .catch(reason => {
              commit(TYPES.SET_ERROR, reason.response.data.message);
              commit(TYPES.SET_LOADING, false);
            });

        }else{
          commit(TYPES.SET_ERROR, reason.response.data.message);
          commit(TYPES.SET_LOADING, false);
        }
      })
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}